import { render, staticRenderFns } from "./FacetAcademicPeriod.vue?vue&type=template&id=3ad07014&scoped=true&"
import script from "./FacetAcademicPeriod.vue?vue&type=script&lang=ts&"
export * from "./FacetAcademicPeriod.vue?vue&type=script&lang=ts&"
import style0 from "./FacetAcademicPeriod.vue?vue&type=style&index=0&id=3ad07014&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ad07014",
  null
  
)

export default component.exports